let app = {};
$('.autoplay').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows: false,
    responsive: [
            {
            breakpoint: 1440,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1
                }
            },
            {
            breakpoint: 1300,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
                }
            },
            {
            breakpoint: 841,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
                }
            },
            {
            breakpoint: 551,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
                }
            },
            {
            breakpoint: 375,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
                }
            }
        ]
});
$(function () {
    $('.featued-cars').slick({
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="featued__slice-prev slick-prev"><img src="app/image/icon/prev.png" alt="prev"></button>',
        nextArrow: '<button type="button" class="featued__slice-next slick-next"><img src="app/image/icon/next.png" alt="next"></button>',
        responsive: [
            {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
            },
            {
            breakpoint: 800,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: false
            }
            },
            {
            breakpoint: 540,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false
            }
            }
        ]
    });
});

$('.storis-inner').slick({  
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    autoplay: true,
    arrows: false,
    prevArrow: '<button class="storis-prev"><img src="app/image/icon/prev-grey.png" alt="prev"></button>',
    nextArrow: '<button class="storis-next"><img src="app/image/icon/next-grey.png" alt="next"></button>',
        responsive: [
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: true,
                    dots: false,
                    autoplay: false
                }
            }
        ]
});

function openNav() {
  document.getElementById("nav-mob").style.width = "100%";
}
function closeNav() {
  document.getElementById("nav-mob").style.width = "0%";
}

